import React from "react";
import IFormikProps from "../../interfaces/others/IFormikProps";
import ModalContainer from "../ModalContainer.tsx";
import AddDocument from "./AddDocument.tsx";

interface DocTypeItem {
  id: number;
  name: string;
  obligatory?: boolean;
  maxDayToUpload?: number;
}

const DocumentationPosition = ({
  formik,
  inmediate,
  list,
  originalField,
  originalList
}: IFormikProps & {
  inmediate?: boolean;
  list: Array<DocTypeItem>;
  originalList: Array<DocTypeItem>;
  originalField: string;
}) => {
  const error = formik.touched[originalField] && formik.errors[originalField];
  const [showModal, setShowModal] = React.useState(false);

  const handleDelete = (index: number) => {
    const newValues = [...formik.values[originalField]];
    newValues.splice(index, 1);
    formik.setFieldValue(originalField, newValues);
  };

 

  return (
    <React.Fragment>
      <div style={{ display: "flex", flexDirection: "row", marginTop: "1%" }}>
        <div className="col-md-1" />
        <div className="col-md-6">
          <button
            type="button"
            className={`btn btn-outline-${error ? "danger" : "secondary"}`}
            onClick={() => setShowModal(true)}
          >
            <i className="fas fa-plus"></i> Agregar documento
          </button>

          <div
            className="invalid-feedback"
            style={{ marginTop: "1px", display: "flex", marginLeft: "0.25em" }}
          >
            {formik.touched[originalField] && formik.errors[originalField] && (
              <>{formik.errors[originalField]}</>
            )}
          </div>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "row", marginTop: "1%" }}>
        <div className="col-md-1" />

        <div className="widget-list rounded">
          {originalList &&
            formik.values[originalField].map((doc, index) => {
              const docType = originalList.find((d) => d.id === doc.idDoc);
              return (
                <a className="widget-list-item" key={index}>
                  <div className="widget-list-media icon">
                    <a style={{ cursor: "pointer" }}>
                      <i
                        className="fa fa-trash bg-yellow text-dark"
                        onClick={() => handleDelete(index)}
                      ></i>
                    </a>
                  </div>
                  <div className="widget-list-content" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <h4 className="widget-list-title mb-0">
                      {docType?.name || ""}
                    </h4>
                    {inmediate && docType != null && (
                      <span style={{
                        backgroundColor: (docType.maxDayToUpload ?? 0) > 0 ? "#fef9c3" : "#f3f4f6",
                        color: (docType.maxDayToUpload ?? 0) > 0 ? "#854d0e" : "#6b7280",
                        padding: "2px 8px", borderRadius: "999px", fontSize: "12px", fontWeight: 600
                      }}>
                        {(docType.maxDayToUpload ?? 0) > 0 ? `${docType.maxDayToUpload} días máx.` : "Sin límite"}
                      </span>
                    )}
                  </div>
                </a>
              );
            })}
        </div>
      </div>
      <ModalContainer
        open={showModal}
        closeFn={() => setShowModal(false)}
        title="Agregar documento"
        children={
          <AddDocument
            formik={formik}
            documentList={list}
            closeFn={() => setShowModal(false)}
            originalField={originalField}
          />
        }
      />
    </React.Fragment>
  );
};

export default DocumentationPosition;
